<mwe-pre-load-data
  [loadingSpinnerType]="extendedLoadingSpinner() ? 'extended' : 'normal'"
  [state]="state()"
  [successTemplate]="success"
  alertMessageKey="error.service.default.message"
  alertTitleKey="error.service.default.title"
/>

<ng-template #success>
  @if (addressOptions()?.length >= 0) {
    <ng-container>
      <div class="row g-4 g-lg-5" role="list">
        @for (option of addressOptions(); track $index) {
          <div class="col-md-6" data-test="selection-card-container">
            <mwe-basic-card-clickable
              cssClass="h-100"
              role="listitem"
              [attr.data-test]="'mwe-address-' + $index"
              (cardClicked)="selectOption(option.address, option.products)"
            >
              <h2 class="h6 mb-1" data-test="mwe-selection-card-header">{{ getAddressGroupFormatted(option.address) }}</h2>
              @if (option.address.addressGroup.groupName) {
                <p class="mb-0" data-test="mwe-selection-card-content">{{ option.address.addressGroup.groupName }}</p>
              }
            </mwe-basic-card-clickable>
          </div>
        }
      </div>
    </ng-container>
  }

  @if (hasNoAddressOption()) {
    <mwe-no-associations-found-warning
      (productSearchBtnClicked)="productSearchBtnClicked.emit()"
      [navigatingBackTo]="navigatingBackTo()"
      [noAddressGroupsText]="noAddressGroupsText()"
      [noAddressGroupsTitle]="noAddressGroupsTitle()"
    />
  }
</ng-template>
